
import { createElement } from "react";
import react from "react";

export const reactApi = react;

export const reactElement = createElement;

